import { useGetFileQuery } from 'features/mediaLibrary/mediaApi';

/**
 * @param {string} [uri]
 *
 * @returns {import('models/files.models').Upload | undefined}
 */
export function useGetFile(uri) {
    const { file } = useGetFileQuery(uri, {
        selectFromResult: ({ data }) => ({
            file: data,
        }),
        skip: !uri,
    });

    return file;
}
